import { formatTimeToPeriod, formatTimeToDayTime } from '../helpers';

export { TimeSlotsSections } from './TimeSlotsSections';
export { FormattedTimeSlotsList } from '../time-slots-list';

export const formatSlots = { formatTimeToPeriod, formatTimeToDayTime };
